jQuery(document).ready(function ($) {
  // slide function
  InitSlider();

  $(".sw-sec-tb-button").on("click", function () {
    var ele = $(this),
      getData = ele.attr("data-type"),
      isActive = ele.hasClass("active");

    $(".sw-sec-tb-product").removeClass("active");
    $(".sw-sec-tb-button").removeClass("active");

    if (!isActive) {
      ele.addClass("active");
      $('.sw-sec-tb-product[data-type="' + getData + '"]').addClass("active");
    }
  });
});

function InitSlider() {
  if (jQuery(".js-hero-slider").length) {
    new Swiper(".js-hero-slider", {
      loop: true,
      spaceBetween: 15,

      navigation: {
        nextEl: ".sw-sec-hero .sw-sec-hero-btn.next",
        prevEl: ".sw-sec-hero .sw-sec-hero-btn.prev",
      },
    });
  }

  if (jQuery(".js-happy-customers").length) {
    new Swiper(".js-happy-customers", {
      slidesPerView: 1.2,
      spaceBetween: 16,
      breakpoints: {
        576: {
          slidesPerView: 1.7,
          spaceBetween: 22,
        },
        768: {
          slidesPerView: 2.7,
          spaceBetween: 22,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 32,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: ".sw-sec-happy-customer .sw-sec-hero-btn.next",
        prevEl: ".sw-sec-happy-customer .sw-sec-hero-btn.prev",
      },
    });
  }

  // if (jQuery(".js-marquee").length) {
  //   new Swiper(".js-marquee", {
  //     loop: true,
  //     slidesPerView: 1,
  //     spaceBetween: 48,
  //     speed: 6000,
  //     autoplay: {
  //       delay: 1,
  //       disableOnInteraction: false,
  //     },
  //     allowTouchMove: false,
  //     freeMode: true,
  //     freeModeMomentum: false,
  //     breakpoints: {
  //       320: {
  //         slidesPerView: 2,
  //       },
  //       576: {
  //         slidesPerView: 3,
  //       },
  //       768: {
  //         slidesPerView: 4,
  //       },
  //       992: {
  //         slidesPerView: 5,
  //       },
  //       1200: {
  //         slidesPerView: 6,
  //       },
  //       1400: {
  //         slidesPerView: 7,
  //       },
  //     },
  //   });
  // }
}

// featured tab collection js ============

// document.addEventListener("DOMContentLoaded", function () {
//   function initSwiper() {
//     document
//       .querySelectorAll(".new_collection_slider")
//       .forEach(function (sliderEl) {
//         if (!sliderEl.swiper) {
//           new Swiper(sliderEl, {
//             slidesPerView: 1.2,
//             spaceBetween: 15,
//             breakpoints: {
//               640: {
//                 slidesPerView: 2.2,
//               },
//               768: {
//                 slidesPerView: 3.2,
//               },
//               1024: {
//                 slidesPerView: 4,
//               },
//             },
//           });
//         }
//       });
//   }

//   initSwiper();

// var dropdown = document.querySelector(".featured_collection_dropdown");

//   dropdown.addEventListener("change", function () {
//     var selectedValue = this.value;
  
//     document
//       .querySelectorAll(".collection-listing")
//       .forEach(function (collection) {
//         collection.style.display = "none";
//       });
  
//     var selectedCollection = document.querySelector("." + selectedValue);
//     if (selectedCollection) {
//       selectedCollection.style.display = "block";
//     }
//      setTimeout(() => initSwiper(), 100);
//   });

// });

document.addEventListener("DOMContentLoaded", function () {
  function initSwiper() {
    document.querySelectorAll(".new_collection_slider").forEach(function(sliderEl) {
      if (!sliderEl.swiper) {
        new Swiper(sliderEl, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          breakpoints: {
            640: { slidesPerView: 2.2 },
            768: { slidesPerView: 3.2 },
            1024: { slidesPerView: 4 }
          }
        });
      }
    });
  }

  initSwiper();

  // Tab functionality
  const tabs = document.querySelectorAll('.collection-tab');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Hide all collections
      document.querySelectorAll('.collection-listing').forEach(collection => {
        collection.style.display = 'none';
      });
      
      // Show selected collection
      const target = this.dataset.target;
      const selectedCollection = document.querySelector('.' + target);
      if (selectedCollection) {
        selectedCollection.style.display = 'block';
        
        // Reinitialize swiper for the newly shown collection
        const swiperEl = selectedCollection.querySelector('.new_collection_slider');
        if (swiperEl && !swiperEl.swiper) {
          new Swiper(swiperEl, {
            slidesPerView: 1.2,
            spaceBetween: 15,
            breakpoints: {
              640: { slidesPerView: 2.2 },
              768: { slidesPerView: 3.2 },
              1024: { slidesPerView: 4 }
            }
          });
        }
      }
      
      // Scroll tab into view if needed
      this.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    });
  });
});



// header mega menu slider ==============

document.addEventListener("DOMContentLoaded", function () {
  function initSwiper() {
    document
      .querySelectorAll(".new_megamenu_slider")
      .forEach(function (sliderEl) {
        if (!sliderEl.swiper) {
          new Swiper(sliderEl, {
            slidesPerView: 1.2,
            spaceBetween: 15,
            breakpoints: {
              640: {
                slidesPerView: 2,
              },
              800: {
                slidesPerView: 2.2,
              },
              1200: {
                slidesPerView: 3,
              },
              1441: {
                slidesPerView: 4,
              },
            },
          });
        }
      });
  }

  initSwiper();

});



// header mega menu tabify js=================
// document.addEventListener("DOMContentLoaded", function () {
//     let tabs = document.querySelectorAll(".mega-menu-tab");
//     let panels = document.querySelectorAll(".mega-menu-content .mega-menu-panel");
//     let tagBlocks = document.querySelectorAll(".collection_tags_block");

//     tabs.forEach(tab => {
//         tab.addEventListener("click", function () {
//             let targetPanels = document.querySelectorAll(`.mega-menu-content .mega-menu-panel[data-id="${this.dataset.tab}"]`);
//             let targetTagBlocks = document.querySelectorAll(`.collection_tags_block[data-tag-panel="${this.dataset.tab}"]`);

//             // Remove active class from all tabs, panels, and tag blocks
//             tabs.forEach(t => t.classList.remove("active"));
//             panels.forEach(p => p.classList.remove("active"));
//             tagBlocks.forEach(tb => tb.classList.remove("active"));

//             // Add active class to clicked tab
//             this.classList.add("active");

//             // Add active class to matching panels
//             targetPanels.forEach(panel => panel.classList.add("active"));

//             // Add active class to matching tag blocks
//             targetTagBlocks.forEach(tagBlock => tagBlock.classList.add("active"));
//         });
//     });

//     // Set the first tab and its corresponding panels active by default
//     if (tabs.length > 0) {
//         tabs[0].classList.add("active");

//         let firstPanels = document.querySelectorAll(`.mega-menu-content .mega-menu-panel[data-id="${tabs[0].dataset.tab}"]`);
//         let firstTagBlocks = document.querySelectorAll(`.collection_tags_block[data-tag-panel="${tabs[0].dataset.tab}"]`);

//         firstPanels.forEach(panel => panel.classList.add("active"));
//         firstTagBlocks.forEach(tagBlock => tagBlock.classList.add("active"));
//     }
// });


document.addEventListener("DOMContentLoaded", function () {
    let tabs = document.querySelectorAll(".mega-menu-tab");
    let panels = document.querySelectorAll(".mega-menu-content .mega-menu-panel");
    let tagBlocks = document.querySelectorAll(".collection_tags_block");

    function resetActiveClasses() {
        tabs.forEach(t => t.classList.remove("active"));
        panels.forEach(p => p.classList.remove("active"));
        tagBlocks.forEach(tb => tb.classList.remove("active"));
    }

    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            let targetPanels = document.querySelectorAll(`.mega-menu-content .mega-menu-panel[data-id="${this.dataset.tab}"]`);
            let targetTagBlocks = document.querySelectorAll(`.collection_tags_block[data-tag-panel="${this.dataset.tab}"]`);

            if (window.innerWidth <= 767) {
                let isActive = this.classList.contains("active");

                resetActiveClasses();

                if (!isActive) {
                    this.classList.add("active");
                    targetPanels.forEach(panel => panel.classList.add("active"));
                    targetTagBlocks.forEach(tagBlock => tagBlock.classList.add("active"));
                }
            } else { 
                resetActiveClasses();
                this.classList.add("active");
                targetPanels.forEach(panel => panel.classList.add("active"));
                targetTagBlocks.forEach(tagBlock => tagBlock.classList.add("active"));
            }
        });
    });

    // Default Active State (Only for Desktop)
    if (tabs.length > 0 && window.innerWidth > 767) {
        tabs[0].classList.add("active");
        let firstPanels = document.querySelectorAll(`.mega-menu-content .mega-menu-panel[data-id="${tabs[0].dataset.tab}"]`);
        let firstTagBlocks = document.querySelectorAll(`.collection_tags_block[data-tag-panel="${tabs[0].dataset.tab}"]`);

        firstPanels.forEach(panel => panel.classList.add("active"));
        firstTagBlocks.forEach(tagBlock => tagBlock.classList.add("active"));
    }
});

// mobile mega menu js ===============

// document.addEventListener("DOMContentLoaded", function () {
//     function handleAccordion() {
//         let tabs = document.querySelectorAll(".mega-menu-tab");

//         tabs.forEach(tab => {
//             tab.addEventListener("click", function () {
//                 let targetPanel = document.querySelector(`.mega-menu-panel[data-id="${this.dataset.tab}"]`);
//                 let icon = this.querySelector(".accordion-icon");

//                 document.querySelectorAll(".mega-menu-panel").forEach(panel => {
//                     if (panel !== targetPanel) {
//                         panel.classList.remove("active");
//                     }
//                 });

//                 document.querySelectorAll(".mega-menu-tab").forEach(btn => {
//                     if (btn !== this) {
//                         btn.classList.remove("active");
//                         btn.querySelector(".accordion-icon").textContent = "+";
//                     }
//                 });

//                 if (targetPanel) {
//                     targetPanel.classList.toggle("active");
//                     this.classList.toggle("active");

//                 }
//             });
//         });
//     }

//     function checkScreenSize() {
//         if (window.innerWidth <= 767) {
//             handleAccordion();
//         }
//     }

//     checkScreenSize();
//     window.addEventListener("resize", checkScreenSize);
// });

// $(document).ready(function () {
//     $(".mega-menu-tab").on("click", function () {
//         var panelId = $(this).data("tab");

//         $(".mega-menu-tab").removeClass("active");
//         $(this).addClass("active");

//         $(".mega-menu-panel.active, .collection_tags_block.active").fadeOut(300, function () {
//             $(this).removeClass("active");

//             // Fade in new panel
//             $(".mega-menu-panel[data-id='" + panelId + "']").fadeIn(300).addClass("active");
//             $(".collection_tags_block[data-tag-panel='" + panelId + "']").fadeIn(300).addClass("active");
//         });
//     });
// });


$(document).ready(function(){
    $(".mega-menu-tab-panel-wrapper").click(function(){
        var $panel = $(this).find(".mega-menu-panel");
        var $tab = $(this).find(".mega-menu-tab");

        // If panel is already active, remove active class and fade out
        if ($panel.hasClass("active")) {
            $panel.removeClass("active").fadeOut();
            $tab.removeClass("active");
        } else {
            // Remove active class from all tabs and panels
            $(".mega-menu-tab, .mega-menu-panel").removeClass("active");
            $(".mega-menu-panel").fadeOut();

            // Add active class to the clicked tab and panel
            $tab.addClass("active");
            $panel.addClass("active").fadeIn();
        }
    });
});




  // document.getElementById("collectionDropdown11").addEventListener("change", function() {
  //     var selectedUrl = this.value;
  //     if (selectedUrl) {
  //         window.location.href = selectedUrl; // Redirect to selected collection page
  //     }
  // });





document.addEventListener("DOMContentLoaded", function() {
  // Collection list logic
  var collectionItems = document.querySelectorAll('.collections-list .collection-item');
  var collectionsList = document.querySelector('.collections-list');
  var currentUrl = window.location.pathname;
  
  // Extract base collection path (remove tag part if exists)
  var baseCollectionPath = currentUrl.split('/tag/')[0];
  if (baseCollectionPath === currentUrl) {
    baseCollectionPath = currentUrl.split('/').slice(0,3).join('/');
  }

  // Set active collection and scroll to it
  var activeItem = null;
  collectionItems.forEach(function(item) {
    var link = item.querySelector('.collection-link');
    if (link.getAttribute('href') === baseCollectionPath || 
        link.getAttribute('href') === currentUrl) {
      item.classList.add('active');
      activeItem = item;
    } else {
      item.classList.remove('active');
    }
  });

  // Scroll to active item on load
  if (activeItem) {
    setTimeout(function() {
      const container = activeItem.parentElement.parentElement;
      const containerWidth = container.offsetWidth;
      const itemOffset = activeItem.offsetLeft;
      const itemWidth = activeItem.offsetWidth;
      
      // Calculate scroll position to center the item
      const scrollTo = itemOffset - (containerWidth / 2) + (itemWidth / 2);
      
      container.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    }, 100);
  }

  // Rest of your tag filtering code...
});
